import { combineReducers } from "redux";
import created from "./masterLeague/created";
import masterLeagueByStatus from "./masterLeague/masterLeagueByStatus";
import masterLeagueRestart from "./masterLeague/masterLeaguesRestart";

export default combineReducers({
    created,
    masterLeagueByStatus,
    masterLeagueRestart,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/masterLeague.js